export default "__VITE_ASSET__600d741c__"